<template>
  <div>
    <!-- Button Cambio de paquete -->
    <button
      type="button"
      id="btnCambioDePaquete"
      class="btn btn-primary"
      data-bs-toggle="modal"
      data-bs-target="#cambioDePaquete"
      style="display: none;"
    >
      Modal Cambio de paquete
    </button>

    <!-- Modal Cambio de paquete -->
    <div
      class="modal fade"
      id="cambioDePaquete"
      tabindex="-1"
      aria-labelledby="cambioDePaqueteLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body text-center p-0">
            <img
              src="./../assets/images/CambiarPaqueteLatino.png"
              alt="Logo Latino Seguros"
              class="img-fluid"
            />
            <div
              class="row d-flex align-items-center mt-4"
              v-for="item in paquetes"
            >
              <div class="col">
                <!--<h5 class="title">{{ item.PAQUETE }}</h5>
                <h5>${{ item.PRIMATOTAL }}</h5>-->
                <h5 class="title">¡Gracias!</h5>
                <h5>Estamos revisando toda tu información para enviarte tu póliza</h5>
              </div>
              <!--<div class="col">
                <button
                  type="button"
                  id="btnGeneraCotizacion"
                  class="btn btn-outline-primary btn-rounded"
                  style="display: none;"
                  @click="
                    guardarCambios({
                      gastos: item.GASTOSEXPEDICION,
                      paquete: item.TIPOPAQUETE,
                      iva: item.IVA,
                      primaneta: item.PRIMANETA,
                      recargo: item.RECARGO,
                      subtotal: item.SUBTOTAL,
                      primatotal: item.PRIMATOTAL,
                      coberturas: item.COBERTURAS,
                    })
                  "
                >
                  ¡Lo quiero!
                </button>
              </div>-->
            </div>
            <hr />
            <button
              type="button"
              class="btn btn-sm btn-primary btn-rounded mb-4"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    paquetes: Array,
    guardarCambios: Function,
  },
  data: function() {
    return {};
  },
  methods: {
    onChange() {
      this.$emit("update:value", this.model);
    },
  },
};
</script>
